import Vue from 'vue'
import { cancelAllSpeech } from '@shared/utils/speech';
import { Message } from 'element-ui';
import { getStoredUserToken, isTokenExpired } from '@shared/utils/token-status.js';
import VueRouter from 'vue-router';
Vue.use(VueRouter);
const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () =>
      import('../views/Login.vue'),
    meta: {
      title: '登录'
    }
  },
  {
    path: '/zhimingCourse',
    name: 'zhimingCourse',
    component: () =>
      import('../views/zhimingCourse.vue'),
  },
  {
    path: '/courseList',
    name: 'courseList',
    component: () =>
      import('../views/CourseList/index.vue'),
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/Home/index.vue'),
    meta: { title: '主页' },
    redirect: '/homework', // 蛇者重定向 进入 home页就默认进入homewrok
    refreshData: false,
    children: [
      {
        path: '/homework',
        name: 'Homework',
        component: () => import('../views/Homework/index.vue'),
        meta: {
          title: '学程列表',
          refreshData: true // 需要刷新数据
        },
      },
      {
        path: '/courseExplanation',
        name: 'CourseExplanation',
        component: () => import('../views/CourseExplanation/index.vue'),
        meta: {
          title: '学程讲解',
          refreshData: true // 需要刷新数据
        },
      },
      {
        path: '/courseware',
        name: 'Courseware',
        component: () => import('../views/Courseware/index.vue'),
        meta: {
          title: '课件详情',
          refreshData: true // 需要刷新数据
        },
      },
      {
        path: '/teacherTrain',
        name: 'TeacherTrain',
        component: () => import('../views/TeacherTrain/index.vue'),
        meta: {
          title: '教培列表',
          refreshData: true // 需要刷新数据
        },
      },
    ]
  },
  {
    path: '/studentData',
    name: 'StudentData',
    component: () =>
      import('../views/StudentData/index.vue'),
    meta: {
      title: '学生数据',
      refreshData: true // 需要刷新数据
    }
  },
  {
    path: '/help',
    name: 'help',
    component: () =>
      import('../views/helpView/index.vue'),
    meta: {
      title: '帮助页面',
      refreshData: true // 需要刷新数据
    }
  },
  

  {
    path: '/typeWriting',
    name: 'TypeWriting',
    component: () =>
      import('../views/StudentData/typeWriting.vue'),
    meta: {
      title: '头脑风暴',
      refreshData: true // 需要刷新数据
    }
  },
  {
    path: '/typeWritingMath',
    name: 'typeWritingMath',
    component: () =>
      import('../views/StudentData/typeWritingMath.vue'),
    meta: {
      title: '表现评价',
      refreshData: true // 需要刷新数据
    }
  },
  {
    path: '/compositionEvaluation',
    name: 'CompositionEvaluation',
    component: () =>
      import('../views/StudentData/compositionEvaluation.vue'),
    meta: {
      title: '作文评价',
      refreshData: true // 需要刷新数据
    }
  },
  {
    path: '/combinCompositionEvaluation',
    name: 'CombinCompositionEvaluation',
    component: () =>
      import('../views/StudentData/combinCompositionEvaluation.vue'),
    meta: {
      title: '组合作文评价',
      refreshData: true // 需要刷新数据
    }
  },
  {
    path: '/CompositionEvaluationGroup',
    name: 'CompositionEvaluationGroup',
    component: () =>
      import('../views/StudentData/compositionEvaluationGroup.vue'),
    meta: {
      title: '小组作文评价',
      refreshData: true // 需要刷新数据
    }
  },
  {
    path: '/report',
    name: 'Report',
    component: () =>
      import('../views/report/index.vue'),
    meta: {
      title: '作文报告',
      refreshData: true // 需要刷新数据
    }
  },
  {
    path: '/studentReport',
    name: 'studentReport',
    component: () =>
      import('../views/studentReport/index.vue'),
    meta: {
      title: '学生报告',
      refreshData: true // 需要刷新数据
    }
  },
  {
    path: '/reportV2',
    name: 'reportV2',
    component: () => import('../views/ReportV2/index.vue'),
    meta: {
      title: '学习报告V2',
      refreshData: true
    }
  },
];

// 依赖授课流程题目数据(zhimingTopicData)的页面家族, 路由守卫据此拦截无数据直入
const FLOW_TOPIC_PATHS = [
  '/studentData', '/typeWriting', '/typeWritingMath',
  '/compositionEvaluation', '/combinCompositionEvaluation', '/CompositionEvaluationGroup'
];
// 依赖备课/授课计划数据(zhimingPlanData)的页面
const FLOW_PLAN_PATHS = ['/report', '/studentReport', '/courseware'];
// 按解析后的值判断(getItem 对字符串 "null" 也返回真, 会骗过存在性检查)
function hasFlowData(key) {
  const raw = localStorage.getItem(key);
  return !!(raw !== null && JSON.parse(raw));
}

const router = new VueRouter({
  mode: 'hash',
  base: '/zmTeach',
  routes,
});
router.beforeEach(async (to, from, next) => {
  // 路由切换统一停止语音讲解(此时离开页面的iframe仍在DOM, 可正常取消)
  if (to.path !== from.path) {
    try { cancelAllSpeech() } catch (e) { /* 忽略 */ }
  }
  const urlParams = new URLSearchParams(window.location.search)
  const code = urlParams.get('code')
  const accessToken = urlParams.get('accessToken')
  const state = urlParams.get('state')
  const { oauthEnabled } = await import('@/utils/oauthConfig')

  // 第三方免密登录仅科大讯飞环境启用(oauthEnabled=false 时整段跳过, 生产/测试构建不含此逻辑)
  if (oauthEnabled && code && !accessToken) {
    const { redirectToAuthorizeAndGrant } = await import('@/api/oauth')
    redirectToAuthorizeAndGrant('szlonghua', code)
    return
  }

  if (oauthEnabled && accessToken && state) {
    await handleOAuthLogin(accessToken, state, next)
    return
  }
  
  if (to.path == '/login') {
    next();
  } else {
    // token 过期前置拦截(2026-10-30): 原只查键存在即放行, 24h 过期后教师一路可浏览,
    // 直到 console 验签接口才 401——过期提示并跳登录; 无 token 保持原静默跳登录
    const storedToken = getStoredUserToken();
    if (!storedToken) {
      next('/login');
      return;
    }
    if (isTokenExpired(storedToken)) {
      Message({ type: 'warning', message: '登录已过期，请重新登录' });
      next('/login');
      return;
    }
    if (to.path == '/homework') {
      // 注意: 不清空 coursewareList/coursewarevideoList, 确认备课保存的数据要带入授课页(清空会导致授课页悬浮课件列表为空)
      // 悬浮课件列表只在授课讲解页显示, homework 页不显示
      localStorage.removeItem('notify')
      localStorage.setItem('courseButton', false)
      localStorage.removeItem('NOteach')
      sessionStorage.clear()
    }
    if (to.path == '/courseExplanation') {
      localStorage.setItem('courseButton', true)
    }
    if (to.path =='/courseware') {
      localStorage.setItem('courseButton',false)
    }
    // 流程数据守卫: 以下页面依赖授课/备课流程写入 localStorage 的数据, 缺失时直接进入会在 data()/mounted 整页级联崩溃,
    // 统一拦回学程列表(数据页家族读 zhimingTopicData, 报告/课件页读 zhimingPlanData, 讲解页带 query 的嵌入模式放行)
    if (FLOW_TOPIC_PATHS.includes(to.path) && !hasFlowData('zhimingTopicData')) {
      next('/homework');
      return;
    }
    if (FLOW_PLAN_PATHS.includes(to.path) && !hasFlowData('zhimingPlanData')) {
      next('/homework');
      return;
    }
    if (to.path == '/courseExplanation' && Object.keys(to.query).length === 0 && !hasFlowData('zhimingPlanData')) {
      next('/homework');
      return;
    }
    next();
  }
});

async function handleOAuthLogin(accessToken, state, next) {
  const store = Vue.prototype.$store
  const oauthPlatform = 'szlonghua'
  const { validateState, oauthLoginApi } = await import('@/api/oauth')

  if (!validateState(oauthPlatform, state)) {
    console.error('OAuth state验证失败')
    window.location.href = window.location.pathname
    return
  }

  // 先清 URL 上的 accessToken/state 再请求(凭证不留地址栏)
  window.history.replaceState({}, document.title, window.location.pathname + window.location.hash)

  let loginRes = null
  try {
    loginRes = await oauthLoginApi(oauthPlatform, accessToken)
  } catch (err) {
    // HTTP层错误(404/500/网络异常): 显式提示而非挂死白屏
    console.error('OAuth免登请求异常', err)
    next({ path: '/login', query: { oauthError: '免密登录服务暂不可用，请稍后重试或使用账号登录' } })
    return
  }
  if (loginRes.data.code == "200" && loginRes.data.result && loginRes.data.result.role == "教师") {
    setupLoginSession(loginRes, store)
    next('/')
  } else {
    console.error('OAuth免登失败', loginRes.data)
    next({ path: '/login', query: { oauthError: (loginRes.data && loginRes.data.message) || '平台免密登录失败' } })
  }
}

function setupLoginSession(loginRes, store) {
  if (localStorage.length > 0) {
    for (let i = localStorage.length - 1; i >= 0; i--) {
      if (localStorage.key(i).indexOf('zhiming') != -1) {
        localStorage.removeItem(localStorage.key(i))
      }
    }
  }
  sessionStorage.clear()
  store.commit('getLoginData', loginRes.data.result)
  if (loginRes.data.result.role == "教师") {
    store.commit('getLoginType', "teacher")
  }
  store.commit('getUserTokenData', loginRes.data.result.access_token)
  if (localStorage.getItem('zhimingReportRank')) {
    store.commit('getReportRank', JSON.parse(localStorage.getItem('zhimingReportRank')))
  } else {
    store.commit('getReportRank', 25)
  }
}
export default router;
